/**
 * created by lei lei on 2020/6/20
 * 我的媒体
 */
import React, {Component} from 'react';
import MyMediaInformation from '../components/media/MyMediaInformation'
import {Row, Col, Button, Modal, Select, Input, Upload, Empty, message} from 'antd';
import NumberDocumentsIssued from '../components/numberDocumentsIssued/NumberDocumentsIssued'
import './MyMedia.css'
import WeChatConfigurations from '../components/weChatConfigurations/WeChatConfigurations'
import *as Actions from '../../actions/myMedia'
import {getCurrentUser} from "../../actions";
import *as Utils from '../../utils'
import {connect} from "react-redux";
//getCurrentUser
const {Option} = Select;
const {TextArea} = Input;
let num = 0;

class MyMedia extends Component {

    constructor(props) {
        super(props);
        this.Actions = {...Actions};
        this.state = {
            mediaList: [],
            option: {
                xData: ['周日','周一', '周二', '周三', '周四', '周五', '周六'],
                colorList: ['#FFBF00', '#00A854', '#0E77D1'],
                yData: [/*{
                    name: '1清华大学',
                    data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 9, 9, 9,]
                },*/]

            },
            visible: false,
            type: 2,//媒体类型
            name: '',//媒体名称
            department: '',//主管部门
            director: '',//负责人
            job: '',//负责人职务
            mobile: '',//负责人电话
            anotherDirector: '',//其他负责人
            anotherMobile: '',//其他负责人电话
            description: '',//媒体用途
            file: '',//附件
            createBy: '',//创建人
           // wxName:'',//微信公众号
            optionWeek: {
                xData: ['周日','周一', '周二', '周三', '周四', '周五', '周六'],
                colorList: ['#FFBF00', '#00A854', '#0E77D1'],
                yData: []
            },
            optionMonth: {
                xData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                colorList: ['#FFBF00', '#00A854', '#0E77D1'],
                yData: []
            },
            optionYear: {
                xData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                colorList: ['#FFBF00', '#00A854', '#0E77D1'],
                yData: []
            },
            isUpdate: false,
            departAllList: [],
            departId: null,
        }

    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getMediaList();
        let body={deptIds:this.props.currentUser.deptIds.toString()};
        Actions.newMediaAuthenticationStatus(body,res=>{
            console.log(res);
            if(res.mediaNames&&res.mediaNames.length>0){
                let mark='';
                if(res.mediaNames.length===1){
                    mark='"'+res.mediaNames[0]+'"'+'授权过期，请及时认证或检查配置信息是否正确！';
                }else{
                    mark='"'+res.mediaNames[0]+'"'+'等'+res.mediaNames.length+'个授权过期，请及时认证或检查配置信息是否正确！';
                }
                Modal.confirm({
                    title: '提示',
                    content: mark,
                    okText: '确认',
                    cancelText: '取消',
                });
                let params={
                    ids:res.ids.toString(),
                    flag:false,
                };
                Actions.updateNewMediaAuthenticationStatus(params,res=>{
                    this.getMediaList()
                })
            }
        })

    }

    //获取媒体列表
    getMediaList() {
        getCurrentUser((data)=>{
            let account =data.account;
            let body = {
                strIds:data.deptIds.toString()
            };
            this.Actions.getDeptAndSon(body, (data) => {
                let Data = data.data;
                if (Data && Data.length) {
                    this.setState({
                        departAllList: Data
                    });
                }
            });
            this.Actions.getMediaList(data.deptIds.toString(), (data) => {
                let Data = data.data;
                if (Data && Data.length > 0) {
                    let newData = Data;
                    newData.forEach((item, i) => {
                        if (item.type === 2) {
                            item.iconType = 'weChat';//微信
                            item.authentication = true;//微信的都是已认证
                        } else if (item.type === 3) {
                            item.iconType = 'microBlog';//微博
                        } else if (item.type === 5) {
                            item.iconType = 'tiktok';//抖音
                        }
                    });
                    this.setState({
                        mediaList: newData,
                    });
                    //根据媒体统计；
                    this.getMediaStatistics(newData);
                }else{
                    this.setState({
                        mediaList: [],
                    });
                }

            });
            this.setState({ createBy: account})
        })
        //获取媒体列表；

    }


    //获取媒体统计
    getMediaStatistics(mediaList) {
        let mediaCodes = [];
        mediaList.forEach(item => {
            mediaCodes.push(item.code);
        });
        this.Actions.getMediaStatistics(mediaCodes, (data) => {
            let Data = data.data ? JSON.parse(data.data) : '';
            this.state.optionWeek.yData = Data.week ? Data.week.yData : [];
            let optionWeek = this.state.optionWeek;
            this.state.optionMonth.yData = Data.month ? Data.month.yData : [];
            this.state.optionYear.yData = Data.year ? Data.year.yData : [];
            this.setState({
                option: optionWeek,
                isUpdate: true,
            })

        })
    }


    render() {
        return (
            <div className={'MyMedia'}>
                <div style={{
                    height: 56,
                    lineHeight: '56px',
                    background: 'white',
                    width: '100%',
                    float: 'left',
                    borderBottom: '1px solid #ebebeb'
                }}>
                    <div style={{fontSize: 14, paddingLeft: 20, float: 'left', color: '#333333'}}>
                        媒体列表
                    </div>
                    <div style={{
                        fontSize: 13,
                        right: 0,
                        color: '#0050B3',
                        float: 'right',
                        marginRight: 20,
                        cursor: 'pointer'
                    }}>
                        <Button onClick={() => {
                            this.addMedia()
                        }} type="primary">添加媒体</Button></div>
                </div>
                {this.renderAddMedia()}
                <WeChatConfigurations ref={(WeChatConfigurations) => {
                    this.WeChatConfigurations = WeChatConfigurations;
                }} callBakc={(mediaProperty) => {
                    //微信输入appid 和secritykey的返回
                    this.saveData(mediaProperty);
                }}/>
                <div style={{clear: 'both'}}/>
                <div style={{paddingTop: 20}}>
                    {
                        this.state.mediaList.length > 0 ? this.state.mediaList.map((item, i) => {
                            return (
                                <div style={{float: 'left'}} key={i}>
                                    <MyMediaInformation
                                        title={item.name}
                                        {...item}
                                        authenticationMark={item.authentication ? '已认证' : '未认证'}
                                        authenticationCallback={() => {
                                            this.authentication(item, i)
                                        }}
                                        iconType={item.iconType}
                                        deleteCallback={() => {
                                            //点击删除
                                            this.delete(item)
                                        }}
                                        iconClickCallback={() => {
                                            //点击图标触发事件
                                            //  console.log('点击图标', item)
                                        }}
                                    />
                                </div>

                            )
                        }) : <Empty/>
                    }
                    <div style={{clear: 'both'}}/>
                </div>
                <div style={{height: 1, background: '#ebebeb', marginTop: 20}}/>
                <div style={{
                    height: 56,
                    lineHeight: '56px',
                    background: 'white',
                    width: '100%',
                    float: 'left',
                    borderBottom: '1px solid #ebebeb'
                }}>
                    <div style={{fontSize: 14, paddingLeft: 20, float: 'left', color: '#333333'}}>
                        发文数
                    </div>
                </div>
                <NumberDocumentsIssued
                    option={this.state.option}
                    topBtnClick={(data) => {
                        if (data === "本周") {
                            this.setState({
                                isUpdate: true,
                                option: this.state.optionWeek
                            })
                        } else if (data === "本月") {
                            this.setState({
                                isUpdate: true,
                                option: this.state.optionMonth
                            })
                        } else if (data === "本年") {
                            this.setState({
                                isUpdate: true,
                                option: this.state.optionYear
                            })
                        }
                    }}
                    dataSource={this.state.dataSource}
                />

            </div>
        )
    }

    //渲染新增媒体界面
    renderAddMedia() {
        const props = {
            name: 'file',
            action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
            headers: {
                authorization: 'authorization-text',
            },
            onChange(info) {
                //  console.log(info);
                if (info.file.status !== 'uploading') {
                    //   console.log(info.file, info.fileList);
                }
                if (info.file.status === 'done') {
                } else if (info.file.status === 'error') {
                }
            },
        };
        return (
            <Modal
                title="添加媒体备案表"
                visible={this.state.visible}
                onOk={() => {
                    this.saveMedia();
                }}
                onCancel={() => {
                    this.state.visible = false;
                    this.revert();
                }}
                bodyStyle={{height: 350}}
                width={800}
            >
                <div>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>媒体平台 <span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                            </Col>
                            <Col span={7}><Select className={'myMediaContent'} defaultValue={this.state.type}
                                                  value={this.state.type}
                                                  style={{width: '100%'}}
                                                  onChange={(e) => {
                                                      this.setState({type: e});
                                                  }}>
                                <Option value={2}>公众号</Option>
                                <Option value={3}>微博</Option>
                                <Option value={5}>抖音</Option>
                            </Select></Col>
                            <Col span={2}></Col>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>媒体名称 <span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                            </Col>
                            <Col span={7}><Input className={''} value={this.state.name}
                                                 onChange={(e) => {
                                                     this.setState({name: e.target.value})
                                                 }} placeholder="请输入媒体名称"/></Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>主管部门 <span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                            </Col>
                            <Col span={7}> <Select className={'myMediaContent'}
                                                   value={this.state.departId}
                                                   style={{width: '100%'}}
                                                   onChange={(e) => {
                                                       this.state.departId = e;
                                                       this.setState({})
                                                   }}>
                                <Option value={null}>请选择</Option>
                                {this.state.departAllList.map((item, i) => {
                                    return (
                                        <Option key={i} value={item.id}>{item.name}</Option>
                                    )

                                })

                                }
                            </Select></Col> <Col
                            span={2}></Col>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>负责人<span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                            </Col>
                            <Col span={7}><Input className={''} value={this.state.director}
                                                 onChange={(e) => {
                                                     this.setState({director: e.target.value})
                                                 }} placeholder="请输入负责人"/></Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>负责人职务 <span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                            </Col>
                            <Col span={7}><Input className={''} value={this.state.job}
                                                 onChange={(e) => {
                                                     this.setState({job: e.target.value})
                                                 }} placeholder="请输入负责人职务"/></Col> <Col
                            span={2}></Col>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>负责人电话<span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                            </Col>
                            <Col span={7}><Input className={''} value={this.state.mobile}
                                                 onChange={(e) => {
                                                     this.setState({mobile: e.target.value})
                                                 }} placeholder="请输入负责人电话"/></Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>其它负责人姓名</div>
                            </Col>
                            <Col span={7}><Input className={''} value={this.state.anotherDirector}
                                                 onChange={(e) => {
                                                     this.setState({anotherDirector: e.target.value})
                                                 }} placeholder="请输入其它负责人姓名"/></Col> <Col
                            span={2}></Col>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>其它负责人电话</div>
                            </Col>
                            <Col span={7}><Input className={''} value={this.state.anotherMobile}
                                                 onChange={(e) => {
                                                     this.setState({anotherMobile: e.target.value})
                                                 }} placeholder="请输入其它负责人电话"/></Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>媒体用途 <span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                            </Col>
                            <Col span={7}><TextArea style={{height: 80}} value={this.state.description}
                                                    maxLength={120} onChange={(e) => {
                                this.setState({description: e.target.value})
                            }}/></Col> <Col span={2}></Col>
                            {/*{
                                this.state.type===2? <Col span={4}>
                                    <div className={'myMediaTitle'}>微信公众号<span
                                        style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                                </Col>:null
                            }*/}
                            {/*{
                                this.state.type===2? <Col span={7}><Input className={'myMediaContent'} value={this.state.wxName}
                                                                          onChange={(e) => {
                                                                              this.setState({wxName: e.target.value})
                                                                          }} placeholder="请输入微信公众号"/></Col>:null
                            }*/}


                            {/* <Col span={11}>
                                <Upload {...props}>
                                    <Button>
                                        添加附件
                                    </Button>
                                </Upload>
                            </Col>*/}
                        </div>
                    </Row>
                </div>

            </Modal>
        )
    }


    //添加媒体
    addMedia() {
        this.state.visible = true;
        this.revert();
    }

    saveMedia() {
        //校验数据
        if (this.state.name.trim().length === 0) {
            message.warn('请输入媒体名称');
            return
        }
        if (!this.state.departId) {
            message.warn('请选择主管部门');
            return
        }
        if (this.state.director.trim().length === 0) {
            message.warn('请输入负责人');
            return
        }
        if (this.state.job.trim().length === 0) {
            message.warn('请输入负责人职务');
            return
        }
        let regular = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (!regular.test(this.state.mobile)) {
            message.warn('请输入正确的负责人手机号');
            return
        }

        if (this.state.anotherMobile.trim().length > 0) {
            if (!regular.test(this.state.anotherMobile)) {
                message.warn('请输入正确的其它负责人手机号');
                return
            }
        }
       /* if ( this.state.type===2&&this.state.wxName.trim().length === 0) {
            message.warn('请输入微信公众号');
            return
        }*/


        /* let reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
          if(this.state.mobile.length>0){
              if(!reg.test(this.state.mobile)){
                  message.warn('请输入数字');
                  return;
              }
          }*/

        if (this.state.description.trim().length === 0) {
            message.warn('请输入媒体用途');
            return
        }
        //校验媒体名称是否已存在
        let that = this;
       /* this.Actions.getIsMediaByName(this.state.name, (data) => {
            //true 已存在， false是不存在
            if (data) {
                message.warn('媒体名称已存在');
                return
            } else {*/
                //调取组件打开弹出窗
                if (that.state.type === 2) {
                    //关闭添加媒体备案表界面
                    that.setState({visible: false});
                    //调用保存方法，保存完清空数据
                    // this.saveData();
                    // 打开微信其他配置
                    that.WeChatConfigurations.show(/!*{...this.state}*!/);
                } else {
                    // 媒体不是微信时候直接保存到后台保存完清空数据源
                    that.saveData();
                }
         /*   }
        });*/
    }

    saveData(mediaProperty = {}) {
        let body = {
            "type": this.state.type,
            "name": this.state.name,
            /* "department": this.state.department,*/
            "deptId": this.state.departId,
            "director": this.state.director,
            "job": this.state.job,
            "mobile": this.state.mobile,
            "anotherDirector": this.state.anotherDirector,
            "anotherMobile": this.state.anotherMobile,
            "description": this.state.description,
            "createBy": this.state.createBy,
            "status": 0
        };

        //addMedia
        //添加备案
        this.Actions.addMediaRecord(JSON.stringify(body), (data) => {
            if (data.data) {
                if(!data.data.id){
                   message.warn(data.data);
                    return
                }
                //把备案的id 添加到媒体里面去-----------
                //添加媒体
                let recordId = data.data.id;//媒体备案的id
                let mediaBody = {
                    "isAuthentication": this.state.type===2?true:false,
                    "name": this.state.name,
                    "type": this.state.type,
                    "isRecord": false,
                    "deptId": this.state.departId,
                    "director": this.state.director,
                    "phone": this.state.mobile,
                    "description": this.state.description,
                    "mediaProperty": JSON.stringify(mediaProperty),
                    "level":1,
                   // "wxName":this.state.wxName?this.state.wxName:null
                };
                //旧的mediaCode
                let oldMedia = [];
                this.state.mediaList.forEach(ite => {
                    oldMedia.push(ite.code)
                });
                let userAccount = this.state.createBy;
                this.Actions.addMedia(JSON.stringify(mediaBody), userAccount, oldMedia, recordId, (data) => {
                    message.success('添加成功');
                    //刷新媒体列表
                    this.getMediaList();
                });
                //---------------------------
            } else {
                message.error('添加失败');
            }
            this.state.visible = false;//关闭弹窗
            //清空数据
            this.revert();
        })


        /*  let addUserMedia = {
              userAccount: this.props.currentUser.account,
              mediaCodes: oldMedia}
              //设置用户媒体
          this.Actions.addUserMedia(JSON.stringify(addUserMedia), (data) => {
              console.log('设置用户媒体', data)
              //刷新媒体列表
              this.getMediaList();
          })*/


    }

    //重置输入框数据
    revert() {
        this.setState({
            type: 2,//媒体类型
            name: '',//媒体名称
            deptId: null,//主管部门
            director: '',//负责人
            job: '',//负责人职务
            mobile: '',//负责人电话
            anotherDirector: '',//其他负责人
            anotherMobile: '',//其他负责人电话
            description: '',//媒体用途
            file: '',//附件
            isUpdate: false,
           // wxName:'',
        });
    }

    //点击认证未认证
    authentication(item, i) {
        //微信都是已认证
        if (item.type !== 2) {
            //未认证的去认证
            if (!item.authentication) {
                this.Actions.gotoOAuth(item.id, (data) => {
                    let Data = data;
                    if (Data&&Data.openurl) {
                        let newData = Data;
                        let openurl = Utils.decodeUnicode(newData.openurl);//第三方认证链接
                        window.open(openurl);//打开第三方认证页面去认证
                        //刷新状态
                        this.getMediaList();
                        // console.log(newData);
                        num = 0;
                        this.refreshAuthen(item.id, newData.keycode, i)

                    }
                })
            }
        }

    }

    //刷新认证状态

    refreshAuthen(id, code, i) {
        let body = {
            code: code,
            id: id,
        };
        let that = this;
        this.Actions.isOAuthSuccess(body, (data) => {
            let Data = data;
            if (Data) {
                let body = {
                    isAuthentication: true,
                    id: id
                };
                //更新认证状态
                this.Actions.updateMediaAuthenticationStatus(body, (data) => {
                    // let Data = data.data;
                    //刷新列表
                    this.getMediaList();
                })
            } else {
                if (num < 100) {
                    setTimeout(function () {
                        num++;
                        that.refreshAuthen(id, code, i);
                    }, 3000);
                }
            }
            /* this.state.mediaList[i].authentication = data;
             this.setState({});*/
        })
    }

    //删除媒体
    delete(item) {
        let body={
            mediaId:item.id
        };
        this.Actions.delMediaById(body,(data)=>{
            let Data=data;
            if(Data.result){
            message.success('删除成功');
                this.getMediaList();
            }else{
            message.error('无法删除！');
            }
        });

    }

}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps)(MyMedia);